import { MotionConfig } from 'motion/react'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import { ContentProvider } from '@/content'
import { SoundProvider } from '@/features/audio'
import { routes } from './routes'

const router = createBrowserRouter(routes)

/**
 * Application root.
 *
 * `reducedMotion="user"` makes every Motion animation on the site respect
 * the OS setting automatically — transforms are dropped and only opacity
 * remains — so no individual component has to remember to check.
 *
 * `SoundProvider` sits above the router because the audio context must
 * survive navigation: rebuilding it on every route change would drop the
 * unlock the browser granted on the first gesture and silence the site.
 */
export const App = () => (
  <MotionConfig reducedMotion="user">
    <ContentProvider>
      <SoundProvider>
        <RouterProvider router={router} />
      </SoundProvider>
    </ContentProvider>
  </MotionConfig>
)
